const {
	fillWithDomElements,
	trackGtm,
	trackGtm4,
} = require('util/functions.js');
const { launchModal } = require('util/modalManager');

const CLASS_MODAL = 'modal-controller';
const CLASS_MODAL_TRIGGER = 'modal-trigger';
const CLASS_MODAL_IFRAME = 'ir-email-modal--iframe';
const CLASS_BTN_LABEL = 'ir-email-alert--subscribe';
const CLASS_MODAL_ADDED_CLASS = 'ir-email-modal-partial';

const elementClasses = {
	modal: CLASS_MODAL,
	modalTrigger: CLASS_MODAL_TRIGGER,
	iframe: CLASS_MODAL_IFRAME,
	btnLabel: CLASS_BTN_LABEL,
};

module.exports = {
	init() {
		fillWithDomElements(this, elementClasses);
		this.gigya = !!this.root.dataset.gigya;

		if (this.gigya) this.initGigyaNewsletter();
		this.initModal();
	},
	initModal() {
		this.initialized = false;
		this.modalTrigger.addEventListener('click', () => {
			if (!this.initialized && !this.gigya)
				this.iframe.setAttribute('src', this.iframe.dataset.src);
			launchModal({
				contentContainer: this.modal,
				addedClass: CLASS_MODAL_ADDED_CLASS,
				remain: true,
			});
			this.initialized = true;
			this.handleGTMModalClick();
		});
	},
	handleGTMModalClick() {
		const linkText = this.btnLabel?.innerHTML
			? this.btnLabel.innerHTML
			: this.modalTrigger?.innerHTML;
		trackGtm4({
			event: 'GA4_event_c_newsletter_form_cta',
			newsletter_type: this.root.dataset.screenSet,
			link_text: linkText,
			link_url: this.root.dataset.url,
			widget_name: 'V3-Investor Email Alerts',
		});
		trackGtm({
			eventCategory: 'newsletter subscription',
			eventAction: 'form submit',
			eventLabel: 'start',
		});
	},
	initGigyaNewsletter() {
		if (window.gigya) {
			const screenSetId = this.root.dataset.screenSet;

			window.gigya.accounts.showScreenSet({
				screenSet: screenSetId,
				containerID: 'gigya-form-newsletter',
				deviceType: 'auto',
			});
		}
	},
};
